import { get } from "radash";
import { useEffect, useState } from "react";
import UserService from "src/services/userService";
import { z } from "zod";

import FormEngine, { FormEngineProps } from "@components/FormEngine/FormEngine";
import { InputField } from "@components/FormEngine/types";

export const REGISTRATION_FORM_ID = "base-registration-info-form";
type RegistrationFormProps = {
  data: {
    firstName: string;
    lastName: string;
    state: string;
    insuranceCarrier: string;
  };
  onSubmit: FormEngineProps["onSubmit"];
};
const RegistrationForm = ({ onSubmit, data }: RegistrationFormProps) => {
  const [stateList, setStateList] = useState<string[]>([]);
  const [carrierList, setCarrierList] = useState<string[]>([]);
  useEffect(() => {
    UserService.getStates()
      .then((res) => {
        const states = get(res, "data", []);
        setStateList(states);
      })
      .catch((error) => {});

    UserService.getCarrierList()
      .then((res) => {
        const carriers = get(res, "data", []);
        setCarrierList(carriers);
      })
      .catch((error) => {});
  }, []);

  const formData = {
    role: "Patient",
    state: data.state || "",
    lastName: data.lastName || "",
    firstName: data.firstName || "",
    insuranceCarrier: data.insuranceCarrier || "",
  };

  const nameFieldProps: InputField["fieldProps"] = {
    formatterRules: ["letters", "spaces", "-"],
    formatOnChange: (value) => value.substring(0, 20),
  };

  return (
    <FormEngine
      formId={REGISTRATION_FORM_ID}
      onSubmit={onSubmit}
      data={formData}
      formOptions={{ values: formData }}
      schema={[
        {
          name: "firstName",
          label: "First Name",
          type: "input",
          rule: z.string().min(1),
          fieldProps: nameFieldProps,
        },
        {
          name: "lastName",
          label: "Last Name",
          type: "input",
          rule: z.string().min(1),
          fieldProps: nameFieldProps,
        },
        {
          name: "state",
          label: "State",
          type: "select",
          options: stateList,
          rule: z.string().min(1),
        },
        {
          name: "insuranceCarrier",
          label: "Who is your insurance provider?",
          type: "autocomplete",
          options: carrierList,
          rule: z.string().min(1),
          fieldProps: {
            placeholder: "Type to filter insurance providers...",
            disableMargins: true,
            filterOptions: (options, state) => {
              const filtered = options.filter((option) =>
                option.toLowerCase().includes(state.inputValue.toLowerCase()),
              );

              return ["Carrier Not Listed", ...filtered];
            },
          },
        },
      ]}
    />
  );
};

export default RegistrationForm;
